import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Browse from "./pages/Browse";
import PublicRegistry from "./pages/PublicRegistry";
import Settings from "./pages/Settings";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ThankYous from "./pages/ThankYous";
import Admin from "./pages/Admin";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import { Toaster } from "sonner";

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/register" element={<Shell><Register /></Shell>} />
          <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
          <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Shell><Dashboard /></Shell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/browse"
            element={
              <Shell><Browse /></Shell>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Shell><Settings /></Shell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/r/:slug"
            element={<Shell><PublicRegistry /></Shell>}
          />
          <Route
            path="/thank-yous"
            element={
              <ProtectedRoute>
                <Shell><ThankYous /></Shell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Shell><Admin /></Shell>
              </ProtectedRoute>
            }
          />
          <Route path="/blog" element={<Shell><Blog /></Shell>} />
          <Route path="/blog/:slug" element={<Shell><BlogPost /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
